import React, { memo } from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    embedUrl: PropTypes.string.isRequired,
};

const defaultProps = {};

function InsightsIframe({ embedUrl }) {
    return (
        <iframe
            style={{
                width: '100%',
                height: '100%',
            }}
            frameBorder={0}
            allowFullScreen
            src={embedUrl}
            id="report-frame"
            title="TherigyInsights"
        />
    );
}

InsightsIframe.propTypes = propTypes;
InsightsIframe.defaultProps = defaultProps;

export default memo(InsightsIframe);
